export const environment = {
  production: false,
  okta: {
    clientId: '0oam5wv4buqD8bux3417',
    issuer: 'https://www.identite.leclerc/',
    redirectUri: 'https://portabilite.rec.leclerc',
    scopes: ['openid', 'profile', 'email', 'groups'],
    pkce: true,
  },
  apiUrl: 'https://portabilite.rec.leclerc/api',
}
